import {Model} from "./model";
import {Company} from "./company";
import {Contract} from "./contract";
import {Storage} from "./storage";
import {User} from "./user";

export class Testbed extends Model {

  address?: string;

  identifier?: string;

  company?: Company;

  contracts?: Contract[];

  testers?: User[];

  currentContract?: Contract;

  storage?: Storage;

  weseth2?: boolean;

}
